/** @format */
/**
 * External dependencies
 */
import { combineReducers, plugins, registerStore, use } from '@wordpress/data';
use( plugins.controls );

/**
 * Internal dependencies
 */
import { applyMiddleware, addThunks } from './middleware';
import availability from './availability';
import products from './products';

const store = registerStore( 'woocommerce-bookings-availability', {
	reducer: combineReducers( {
		availability: availability.reducer,
		products: products.reducer,
	} ),

	actions: {
		...availability.actions,
		...products.actions,
	},

	selectors: {
		...availability.selectors,
		...products.selectors,
	},

	resolvers: {
		...availability.resolvers,
		...products.resolvers,
	},

	controls: {
		...availability.controls,
		...products.controls,
	},
} );

applyMiddleware( store, [ addThunks ] );
